module.exports = __webpack_public_path__ + "src/assets/hr.b84cfc31.png";